import React from 'react';
import { C, DISP, BODY, MONO, FadeUp, track, scrollToId } from './shared';

const STEPS = [
  {
    n: '01',
    title: 'Know what to do next',
    body: 'The Daily Growth Plan hands you today\u2019s plan: what to post, the hook to use, and the best time to publish.',
    desktop: '/walkthrough/plan-desktop.jpg',
    mobile: '/walkthrough/plan-mobile.jpg',
    alt: 'ScalitOS Daily Growth Plan showing the hook to use and the posting strategy for today',
  },
  {
    n: '02',
    title: 'Create the work',
    body: 'Describe what you\u2019re promoting in one sentence. The Creative Studio writes the brief and produces the assets.',
    desktop: '/walkthrough/studio-desktop.jpg',
    mobile: '/walkthrough/studio-mobile.jpg',
    alt: 'ScalitOS Creative Studio asking what are you promoting, with a one-sentence input and no design choices required',
  },
  {
    n: '03',
    title: 'Stay consistent',
    body: 'Weekly strategy decks build on what you already shipped. Strategic memory keeps every week sharper than the last.',
    desktop: '/walkthrough/strategy-desktop.jpg',
    mobile: '/walkthrough/strategy-mobile.jpg',
    alt: 'ScalitOS weekly strategy deck with strategist confidence score and strategic memory of past campaigns',
  },
];

const Shot = ({ step }) => (
  <picture>
    <source media="(max-width: 640px)" srcSet={step.mobile} />
    <img
      src={step.desktop}
      alt={step.alt}
      loading="lazy"
      style={{ width: '100%', display: 'block', borderRadius: 14, border: `1px solid ${C.border}`, boxShadow: '0 30px 70px -30px rgba(0,0,0,0.7)' }}
    />
  </picture>
);

export const ProductWalkthrough = () => (
  <div data-testid="product-walkthrough" style={{ marginTop: 72, maxWidth: 1000, marginLeft: 'auto', marginRight: 'auto' }}>
    <FadeUp>
      <p style={{ fontFamily: MONO, fontSize: 11, letterSpacing: '0.2em', color: C.muted, textTransform: 'uppercase', textAlign: 'center', marginBottom: 44 }}>
        Real screens from the live product
      </p>
    </FadeUp>

    <div style={{ display: 'flex', flexDirection: 'column', gap: 'clamp(44px, 6vw, 72px)' }}>
      {STEPS.map((s, i) => (
        <FadeUp key={s.n} delay={i * 80}>
          <div className="scl-two-col" style={{
            display: 'grid', gridTemplateColumns: '0.75fr 1.25fr', gap: 'clamp(20px, 4vw, 44px)', alignItems: 'center',
            direction: i % 2 === 1 ? 'rtl' : 'ltr',
          }}>
            <div style={{ direction: 'ltr' }}>
              <p style={{ fontFamily: DISP, fontWeight: 800, fontSize: 15, color: C.lime, marginBottom: 10 }}>{s.n}</p>
              <h3 style={{ fontFamily: DISP, fontWeight: 700, fontSize: 'clamp(21px, 3vw, 27px)', letterSpacing: '-0.01em', color: C.text, marginBottom: 12, lineHeight: 1.15 }}>{s.title}</h3>
              <p style={{ fontFamily: BODY, fontSize: 15, lineHeight: 1.7, color: C.body, maxWidth: 340 }}>{s.body}</p>
            </div>
            <div style={{ direction: 'ltr' }}>
              <Shot step={s} />
            </div>
          </div>
        </FadeUp>
      ))}
    </div>

    <FadeUp delay={200}>
      <div style={{ marginTop: 56, textAlign: 'center' }}>
        <button
          data-testid="walkthrough-cta"
          className="scl-btn-primary"
          onClick={() => { track('walkthrough_cta_clicked'); scrollToId('scanner'); }}
        >
          Scan my brand free →
        </button>
      </div>
    </FadeUp>
  </div>
);
